<div class="search-wrapper pMngr coreEmployeeSearch" [ngClass]="{'searchMinHeight': !searchedFlag && !(getData())}">
    <div class="MobHeadCsol">
        <h1><span class="hdrTxt fw-normal">Manage Core Services</span>
    
          </h1>
    </div>
    <form [formGroup]="coreEmployeeSearchForm">
        <div class="">
            <div class="coresearch-by-wrapper">
                <div class="radio-mob"><strong>Search by:</strong></div>
                <div class="form-group-radio-check core-radio">
                    <label class="radio">
                        <input type="radio" name="searchBy" [value]="true"
                            [checked]="salesAssignment" (change)="onSearchByTypeChange(true)" formControlName="searchBy"/>
                        <i aria-hidden="true" class="icon-radio"></i>
                        Sales Office Assignments
                    </label>
                    <label class="radio p-mr-0 ">
                        <input type="radio" name="searchBy" [value]="false"
                            [checked]="!salesAssignment" (change)="onSearchByTypeChange(false)" formControlName="searchBy"/>
                        <i aria-hidden="true" class="icon-radio"></i>
                        Current Assignments
                    </label>
                </div>
            </div>
            <div *ngIf="salesAssignment">
                <div class="floating-form-group">
                    <select class="floating-select" formControlName="type" (change)="changeCoreService($event)">
                        <option value="null" >Select</option>
                        <option [value]="type?.id" *ngFor="let type of coreServiceType">
                            {{type?.value}}
                        </option>
                    </select>
                    <label>Core Service Business Type </label>
                </div>
                <div class="floating-form-group mr-20">
                    <span class="p-float-label sales-emp-name">
                        <p-autoComplete
                         formControlName="employeeName" name="employeeName" [disabled]="selectedCoreServiceType === '' && changeSelectedCoreServiceType"
                        [suggestions]="filteredEmployees" field="value" 
                        (completeMethod)="filterEmployee($event)"
                        (onSelect)="enableSubmitBtn()"
                        [showEmptyMessage]="true"
                        [emptyMessage]="'No results found'">
                            <ng-template let-employee pTemplate="item">
                                <div class="country-item">
                                    <div>{{employee.value}}</div>
                                </div>
                            </ng-template>
                        </p-autoComplete>
                        <label class="positionChange" [ngClass]="{'inActiveLabel': (selectedCoreServiceType === '' && changeSelectedCoreServiceType)}">Enter Employee Name</label>
                    </span>
                </div>
                <div class="btnHolder add-btnHolder">
                    <button type="button" class="primaryBtn" [disabled]="disaledSubmitBtnSales" (click)="searchCoreEmployee()">
                        SUBMIT
                    </button>
                    <button type="submit" class="SecondaryBtn" *ngIf="!hideNonEmployeeBtn" (click)="AddNonEmployee()">
                        ADD NON EMPLOYEE
                    </button>
                </div>
            </div>
             <div *ngIf="!salesAssignment" class="formGroup">
                <div class="floating-form-group">
                    <select class="floating-select" 
                            formControlName="type" 
                            (change)="changeCoreService($event)">
                        <option  value="null" >Select</option>
                        <option  *ngFor="let type of coreServiceType" [value]="type?.id">
                            {{type?.value}}
                        </option>
                    </select>
                    <label>Core Service Business Type </label>
                </div>
                <div class="floating-form-group">
                    <select class="floating-select" 
                            formControlName="state"
                            (change)="changeState($event)"  >
                        <option value="null" >Select</option>
                        <option *ngFor="let state of states" [value]="state?.id">
                            {{state?.value}}
                        </option>
                    </select>
                    <label>Select State </label>
                </div>
                <div class="floating-form-group">
                    <select class="floating-select" 
                            formControlName="region"
                            (change)="changeRegion($event)" >
                        <option value="null" >Select</option>
                        <option [value]="region?.id" *ngFor="let region of regions">
                            {{region?.value}}
                        </option>
                    </select>
                    <label>Select Region </label>
                </div>
                <div class="floating-form-group">
                    <span class="p-float-label sales-emp-name">
                        <p-autoComplete
                         formControlName="pcnum" name="pcnum"
                        [suggestions]="filteredPCNumbers"
                        (completeMethod)="filterPCNumber($event)"
                        (onSelect)="selectPCNumber($event)"
                        [forceSelection]="true"
                        (keyup)="onKeyUp($event)" field="id" placeholder="Search by PC Number"
                        [showEmptyMessage]="true"
                        [emptyMessage]="'No results found'">
                        <ng-template let-pc pTemplate="item">
                            <div class="country-item">
                                <div>{{pc.id}}</div>
                            </div>
                        </ng-template>
                        </p-autoComplete>
                        <label class="positionChange">Enter PC Number</label>
                    </span>
                </div>
                <div class="floating-form-group mr-20">
                    <span class="p-float-label sales-emp-name office-name-label">
                        <p-autoComplete 
                         formControlName="officeName" name="officeName" 
                        [suggestions]="filteredOfficeNames"
                        (completeMethod)="filterOfficeName($event)"
                        [forceSelection]="true"
                        (keyup)="onKeyUp($event)"
                        (onSelect)="selectOffice($event)" field="value" placeholder="Search by Office Name"
                        [showEmptyMessage]="true"
                        [emptyMessage]="'No results found'">
                        </p-autoComplete>
                        <label class="positionChange">Enter Office Name</label>
                    </span>
                </div>
                <div class="btnHolder add-btnHolder core-btnHolder">
                    <button type="button" class="primaryBtn" (click)="searchCoreEmployee()" [disabled]="submitDisable">
                        SEARCH
                    </button>
                    <button type="submit" class="SecondaryBtn" [disabled]="submitDisable" (click)="onClear()">
                        CLEAR
                    </button>
                </div>
            </div> 
            
            <div class="instrtuction-wrapper" [ngClass]="{'hideHeading': !infoheading}" *ngIf="!salesAssignment">
                <span class="sub-heading">
                    <span class="info">
                        Please select at least one filter to search
                    </span>
                </span>
            </div>
        </div>
    </form>
    
</div>

<app-custom-confirm-dialogue
  [customClass]="'approved-modal'"
  [title]="'Exception Occurred'"
  [isExceptionModal]="isExceptionModal"
  [okBtnLabel]="'OK'"
  #exceptionModal
>
</app-custom-confirm-dialogue>
<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onConfirm)="searchUpdate()"
  #searchConfirmationModal
>
</app-search-update-confirmation>

<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onCancel)="onCancelUpdatePopup()"
(onConfirm)="changeCoreServiceModal(changeCoreServiceTypeEvent)"
  #changeCoreServiceConfirmationModal
>
</app-search-update-confirmation>

<app-search-update-confirmation
[customClass]="'custom-modal'"
[okBtnLabel]="'Yes'"
[cancelBtnLabel]="'No'"
(onCancel)="onChangeSearchByCancel()"
(onConfirm)="onChangeSearchBy()"
  #changeSearchByModal
>
</app-search-update-confirmation>

